import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';
import { isEmpty, isUndefined } from 'lodash';

/**
 * SaveCodeCategory
 *
 * Saves a single code category with the remote API via an authenticated request.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const SaveCodeCategory = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theMutationKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      data: {},
      headers: {
        'x-api-endpoint': '/code-lists/categories',
      },
      method: 'POST',
      params: { apiKey: theApiKey, mutationKey: theMutationKey },
    };

    if (
      thePayload?.mode === 'edit' &&
      !isUndefined(thePayload?.data?.categoryCode) &&
      !isEmpty(thePayload?.data?.categoryCode)
    ) {
      requestArgs.method = 'PUT';
      requestArgs.headers['x-api-endpoint'] += `/${thePayload?.data?.categoryCode}`;
    }

    requestArgs.data = { ...thePayload?.data };

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse.data;
  } catch (error) {
    logger.error('src/entities/Code/api/requests/mutations/SaveCodeCategory.js -> SaveCodeCategory()', false, error);

    throw error;
  }
};
